import {createGrid} from "../../helpers/grids/grids";
import createElement from "../../helpers/createElement";
import {createCellRenderer, createDoubleClickHandler} from "../../helpers/grids/helpers";
import Axios from "axios";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";
import {loading, stopLoading} from "../../helpers/loading";
import {updateCheckinCounts} from "./updateCheckinCounts";
import {interceptValidationErrors, noValidationErrorsLeft} from "../../helpers/forms/validationErrors/utils";
import Swal from "sweetalert2";
import {randomUniqueClassName} from "../../helpers/inputs/random/strings";
import {waitUntil} from "../../helpers/waitUntil";

// noinspection JSUnusedGlobalSymbols
class CustomNoRowsOverlay {
	init(params) {
		this.params = params;

		this.emptySearchOverlay = document.querySelector('.empty-search-overlay').cloneNode(true);
		this.noVisitorsOverlay = document.querySelector('.no-visitors-overlay').cloneNode(true);
	}

	getGui() {
		// noinspection JSUnresolvedReference
		const gridInstance = this.params.getGridInstance();
		if (gridInstance) {

			const filterValues = gridInstance._getFilterValues();

			if (filterValues.search) {
				return this.noVisitorsOverlay;
			} else {
				return this.emptySearchOverlay;
			}
		}
		return createElement('<div></div>');
	}
}

function initCheckinsIndex() {
	const searchInput = document.querySelector('input[name="search"]')

	searchInput.addEventListener('keydown', e => {
		// Hide onscreen keyboard on enter
		if (e.key === 'Enter' || e.keyCode === 13) {
			if ('virtualKeyboard' in navigator) {
				searchInput.inputMode = 'none';
				navigator.virtualKeyboard.hide();
				searchInput.blur()

				setTimeout(() => {
					searchInput.inputMode = 'search';
				}, 100)
			}
		}
	})

	const grid = createGrid('.checkins-grid', {
			columnDefs: [
				{
					field: "name",
					headerName: 'Actor',
					sortable: false,
					flex: 2,
					autoHeight: true,
					cellClass: 'fill-space',
					cellRenderer: createCellRenderer(renderPersonCell)
				},
				{
					field: "public_id",
					headerName: '',
					minWidth: 180,
					maxWidth: 200,
					flex: 1,
					cellClass: 'fill-space',
					cellRenderer: createCellRenderer(params => {
						// noinspection JSUnresolvedVariable
						const buttons = createElement(`
							<div class="h-100 w-100 d-flex">
								<button
									class="btn btn-primary d-flex align-items-center justify-content-center h-100 rounded-0"
									style="flex: 1"
								>
									Check-in
								</button>
							</div>`
						);

						buttons.querySelector('button').onclick = () => checkinPerson(params.data)

						return buttons;
					})
				},
			],
			rowClass: 'checkin-row',
			pagination: false,
			noRowsOverlayComponent: CustomNoRowsOverlay,
			noRowsOverlayComponentParams: {
				getGridInstance: () => {
					// noinspection JSUnresolvedFunction
					return grid;
				}
			},
			_rowName: 'Actors',
			onRowDoubleClicked: createDoubleClickHandler(data => {
				checkinPerson(data)
			}),
		},
		window['routes/admin.checkins.grid'],
	);

	/**
	 * Methods
	 */

	function renderPersonCell(params) {
		const name = params.data.name;
		// noinspection JSUnresolvedReference
		const job = params.data.description_string;

		// noinspection JSUnresolvedVariable
		return createElement(`
			<div class="position-relative">
				<div class="name">
					${name}
				</div>
				<div class="ml-4 text-uppercase text-monospace" style="font-size: 1.1rem">${job}</div>
			</div>
		`);
	}

	function checkinPerson(person, force = false) {
		// noinspection JSUnresolvedVariable
		const url = person.checkinRoute;

		loading();

		Axios.post(url, {
			households: 1,
			force,
		})
			.then(response => {
				handleAjaxSuccess(response, () => {
					searchInput.value = '';
					grid._refresh();

					// Trigger check in counts update
					updateCheckinCounts();
				})
			})
			.catch((error) => handlePendinContractError(error, person))
			.finally(stopLoading)
	}

	// noinspection DuplicatedCode
	function handlePendinContractError(error, person) {
		// We need to check for custom error handling here
		// for missing contract check
		let interceptedValidationErrors = interceptValidationErrors(error, [
			{
				pattern: /PENDING_CONTRACT/,
				handler: (field, signRoute) => {
					// If we have filters, attempt to intercept validation errors
					const buttonRandomClassId = randomUniqueClassName();

					Swal.fire({
						icon: 'error',
						cancelButtonText: 'Cancel',
						confirmButtonText: 'Check-In Anyway',
						showCancelButton: true,
						html: `
							<div>
								<div>
									Staff needs to sign pending contract <br>
									Please share the following link to accept contract
								</div>
								<div class="d-flex flex-row align-items-center">
									<div class="form-group compact form-group compact flex-grow-1">
										<input
											type="text"
											class="form-control form-control-border border-width-2"
											style="background-color: transparent"
											id="display_gender"
											value="${signRoute}"
											autocomplete="off"
											readonly=""
										>
									</div>
									<div class="position-relative  ml-2">
										<button class="btn btn-primary btn-sm ${buttonRandomClassId}">Copy Link</button>
									</div>
								</div>
							</div>
						`,
					})
						.then(result => {
							if (result.isConfirmed) {
								checkinPerson(person, true)
							}
						});

					// Init copy button handler
					waitUntil(() => document.querySelector(`.${buttonRandomClassId}`))
						.then(() => {
							const button = document.querySelector(`.${buttonRandomClassId}`);
							button.addEventListener('click', () => {
								navigator.clipboard.writeText(signRoute).then(() => {
								});
							})
						})
				}
			}
		]);

		// If we didnt intercept anything or there were errors lefts...
		if (interceptedValidationErrors === false || noValidationErrorsLeft(error) === false) {
			///... default error handler
			handleAjaxError(error, this.config.formElement)
		}
	}
}


export {
	initCheckinsIndex
}
